import { learnArticles, getLearnArticleBySlug } from './englishLearnArticles'
import { zhLearnArticles, getZhLearnArticleBySlug } from './zhLearnArticles'
import { articlePairs } from './articlePairs'

export {
  learnArticles,
  zhLearnArticles,
  articlePairs,
  getLearnArticleBySlug,
  getZhLearnArticleBySlug
}

export function getArticleTranslation(language, slug) {
  const pair = articlePairs.find(item => item[language] === slug)
  if (!pair) return null

  if (language === 'zh') {
    return { language: 'en', slug: pair.en, path: `/learn/${pair.en}` }
  }

  return { language: 'zh', slug: pair.zh, path: `/zh/learn/${pair.zh}` }
}
